export const SENDING_REQUEST = 'SENDING_REQUEST';
export const REQUEST_ERROR = 'REQUEST_ERROR';
export const SHOW_PROGRESS_BAR = 'SHOW_PROGRESS_BAR';
export const HIDE_PROGRESS_BAR = 'HIDE_PROGRESS_BAR';
export const CHANGE_BUSINESS_TYPES_DATA = 'CHANGE_BUSINESS_TYPES_DATA';
export const CHANGE_BUSINESS_CATEGORIES_ALL_DATA =
  'CHANGE_BUSINESS_CATEGORIES_ALL_DATA';
export const CHANGE_BUSINESS_STARTS_DATA = 'CHANGE_BUSINESS_STARTS_DATA';
export const CHANGE_BUSINESS_SALES_DATA = 'CHANGE_BUSINESS_SALES_DATA';
export const CHANGE_FORM_REGISTER = 'CHANGE_FORM_REGISTER';
export const CHANGE_FORM_RESET_PASSWORD = 'CHANGE_FORM_RESET_PASSWORD';
export const SET_RESEND_VERIFICATION_EMAIL_STATE =
  'SET_RESEND_VERIFICATION_EMAIL_STATE';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';
